/* ARTICLE 2026 — cikkoldali interakciók (2026-07-13)
   Csak az article template-en töltődik, `defer`-rel.
   Függőség nélküli vanilla JS. Minden mozgás compositor-barát (transform).

   Feladatok:
     1) Tartalomjegyzék építése a törzs H2-iből + scrollspy (aktív elem kiemelése)
     2) Olvasási progress-csík (scaleX, nem width)
     3) Táblázatok becsomagolása vízszintesen görgethető konténerbe
     4) "Link másolása" gomb (Clipboard API)
*/
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    var body = document.querySelector('[data-article-body]');
    if (!body) return;

    wrapTables(body);
    buildToc(body);
    initProgress();
    initCopyLink();
  }

  /* ---------------------------------------------------------------------
     1) TARTALOMJEGYZÉK + SCROLLSPY
     --------------------------------------------------------------------- */
  function buildToc(body) {
    var aside = document.querySelector('[data-article-toc]');
    var list = document.querySelector('[data-article-toc-list]');
    if (!aside || !list) return;

    /* SSR-ág (2026-07-20, villogás-fix): a TOC-ot már a Liquid megépítette
       (snippets/article-toc.liquid), az aside eleve látható — itt csak a
       sima görgetést és a scrollspy-t kötjük a KÉSZ linkekre. A lenti
       dinamikus építés fallbackként marad (pl. ha a snippet kikerülne). */
    var ssrLinks = list.querySelectorAll('a');
    if (ssrLinks.length) {
      var ssrItems = [];
      Array.prototype.forEach.call(ssrLinks, function (a) {
        var target = document.getElementById(decodeURIComponent((a.hash || '').slice(1)));
        if (target) ssrItems.push({ heading: target, link: a });
      });
      if (!ssrItems.length) return;
      aside.hidden = false;
      wireToc(list, ssrItems);
      return;
    }

    var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));

    // Rövid cikknél nincs értelme tartalomjegyzéknek — a blokk rejtve marad.
    if (headings.length < 3) return;

    // Az ALAP-slugonként számolunk, nem a végleges id-nként — különben 3+ azonos
    // szövegű H2-nél a 2. és 3. is ugyanazt az id-t kapná (duplikált id a DOM-ban).
    var slugCount = {};
    var items = [];

    headings.forEach(function (h, i) {
      var text = (h.textContent || '').trim();
      if (!text) return;

      if (!h.id) {
        var base = slugify(text) || ('szakasz-' + (i + 1));
        var n = (slugCount[base] || 0) + 1;
        slugCount[base] = n;
        var id = n > 1 ? base + '-' + n : base;
        // Ha a cikk törzse már használja ezt az id-t, tovább léptetünk.
        while (document.getElementById(id)) {
          n += 1;
          slugCount[base] = n;
          id = base + '-' + n;
        }
        h.id = id;
      }

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = text;
      li.appendChild(a);
      list.appendChild(li);

      items.push({ heading: h, link: a });
    });

    if (!items.length) return;
    aside.hidden = false;
    wireToc(list, items);
  }

  /* Sima görgetés + scrollspy rákötése — közös az SSR- és a dinamikus ágnak. */
  function wireToc(list, items) {
    // Sima görgetés (a scroll-margin-top a CSS-ben kezeli a sticky headert)
    list.addEventListener('click', function (e) {
      var link = e.target.closest('a');
      if (!link) return;
      var target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'start'
      });
      history.replaceState(null, '', link.hash);
    });

    initScrollSpy(items);
  }

  function initScrollSpy(items) {
    var current = null;

    function setActive(entry) {
      if (current === entry) return;
      items.forEach(function (it) { it.link.classList.remove('is-active'); });
      if (entry) entry.link.classList.add('is-active');
      current = entry;
    }

    if (!('IntersectionObserver' in window)) {
      setActive(items[0]);
      return;
    }

    var visible = new Set();

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var item = items.find(function (it) { return it.heading === e.target; });
        if (!item) return;
        if (e.isIntersecting) visible.add(item);
        else visible.delete(item);
      });

      if (visible.size) {
        // A legfelső látható szakasz az aktív.
        var top = null;
        visible.forEach(function (it) {
          if (!top || it.heading.getBoundingClientRect().top < top.heading.getBoundingClientRect().top) {
            top = it;
          }
        });
        setActive(top);
      } else {
        // Egy szakasz sincs a sávban → az utolsó, amit már elhagytunk felfelé.
        var passed = null;
        items.forEach(function (it) {
          var rr = it.heading.getBoundingClientRect(); if (rr.height > 0 && rr.top < 120) passed = it; // 2026-09-25: a rejtett címsor (0 magas) nem „elhagyott”
        });
        setActive(passed || items[0]);
      }
    }, {
      // A sáv a header alatt kezdődik és a képernyő alsó felénél zárul.
      rootMargin: '-110px 0px -55% 0px',
      threshold: 0
    });

    items.forEach(function (it) { observer.observe(it.heading); });
  }

  /* ---------------------------------------------------------------------
     2) OLVASÁSI PROGRESS — scaleX (nem width), rAF-fel csillapítva
     --------------------------------------------------------------------- */
  function initProgress() {
    var fill = document.querySelector('[data-article-progress-fill]');
    var article = document.querySelector('.tn-article');
    if (!fill || !article) return;

    var ticking = false;

    function update() {
      ticking = false;
      var rect = article.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      if (total <= 0) {
        fill.style.transform = 'scaleX(0)';
        return;
      }
      var scrolled = -rect.top;
      var ratio = scrolled / total;
      if (ratio < 0) ratio = 0;
      if (ratio > 1) ratio = 1;
      fill.style.transform = 'scaleX(' + ratio.toFixed(4) + ')';
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ---------------------------------------------------------------------
     3) TÁBLÁZATOK — vízszintesen görgethető konténer (mobil overflow ellen)
     --------------------------------------------------------------------- */
  function wrapTables(body) {
    var tables = body.querySelectorAll('table');
    Array.prototype.forEach.call(tables, function (table) {
      if (table.parentNode && table.parentNode.classList.contains('tn-table-wrap')) return;
      var wrap = document.createElement('div');
      wrap.className = 'tn-table-wrap';
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('tabindex', '0');
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }

  /* ---------------------------------------------------------------------
     4) LINK MÁSOLÁSA
     --------------------------------------------------------------------- */
  function initCopyLink() {
    var btn = document.querySelector('[data-copy-link]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var url = window.location.href.split('#')[0];

      copy(url).then(function () {
        btn.classList.add('is-copied');
        var label = btn.getAttribute('data-copied-label');
        if (label) btn.setAttribute('aria-label', label);
        setTimeout(function () { btn.classList.remove('is-copied'); }, 1800);
      }).catch(function () {
        // Néma bukás helyett legalább a natív megosztó, ha van
        if (navigator.share) navigator.share({ url: url }).catch(function () {});
      });
    });
  }

  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy') ? resolve() : reject();
      } catch (err) {
        reject(err);
      }
      document.body.removeChild(ta);
    });
  }

  /* --------------------------------------------------------------------- */
  function slugify(str) {
    return str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')   // ekezetek le (kombinalo diakritikusok)
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60);
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
})();
